import { subscribe } from "../utils/observer";

const checkOverflow = (element) => {
  element.setAttribute(
    "data-is-scrollable",
    element.scrollHeight > element.clientHeight,
  );
};

export const enhancer = (element) => {
  checkOverflow(element);

  const resizeObserver = new ResizeObserver(() => checkOverflow(element));
  resizeObserver.observe(element);

  subscribe("open-popup", () => checkOverflow(element));
};
